import { MutableRefObject, useEffect, useRef } from "react";

function useStableCallbackRef<T extends (...args: never[]) => unknown>(
  callback: T,
): MutableRefObject<T> {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return callbackRef;
}

export default useStableCallbackRef;
